import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUploadedProForma } from 'types/db/UploadedProForma';

interface IParams {
    organizationUuid: string;
    uploadedProFormaId: number;
    displayName: string;
}

const updateUploadedProFormaDisplayName = async ({
    organizationUuid,
    uploadedProFormaId,
    displayName,
}: IParams): Promise<IUploadedProForma> => {
    const response = await axiosInstance.patch(
        API_ENDPOINTS.UPLOADED_PRO_FORMAS_BY_ID(organizationUuid, uploadedProFormaId),
        { displayName },
    );
    return response.data;
};

export const useUpdateUploadedProFormaDisplayName = () => useMutation({
    mutationFn: updateUploadedProFormaDisplayName,
});

export default useUpdateUploadedProFormaDisplayName;
